import { useCallback, useState } from 'react';
import { TCCOConfiguracoes } from '../../../../../types/api/financeiro/conta-corrente-consumo-configuracoes';
import DialogCriacaoEditCCOConfiguracoes from './DialogCriacaoEdit';
import SessaoConfiguracao, { ConfiguracaoColunas } from '../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao';

export default function CCOConfiguracoes() {

    const [openModal, setOpenModal] = useState<TOpenModalConfiguracoes>(null)

    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TCCOConfiguracoes | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value, edit: true })
        if (action === "open" && !id && !value) setOpenModal({ open: true, defaultValue: null, edit: false })
    }, [])

    return (
        <>
            <SessaoConfiguracao<TCCOConfiguracoes>
                titulo="Conta corrente consumo"
                endpoints={{
                    listar: "financeiro/conta-corrente-consumo/pesquisar-configuracoes",
                    deletar: "financeiro/conta-corrente-consumo/excluir-configuracao",
                }}
                colunas={colunas}
                queryKey="pesquisar-cco-configuracoes"
                onEditar={(config) => {
                    handleModalAction("open", config.id, config)
                }}
                onAdicionar={() => {
                    handleModalAction("open", true, null)
                }}
                mensagemSucessoDeletar="Exclusão da configuração realizada com sucesso!"
                mensagemErroDeletar="Erro ao excluir configuração!"
                mensagemSemDados="Nenhuma configuração encontrada."
            />

            {
                Boolean(openModal?.open) &&
                <DialogCriacaoEditCCOConfiguracoes
                    defaultValue={openModal}
                    open={Boolean(openModal?.open)}
                    handleClose={() => handleModalAction("close")}
                />
            }
        </>
    );
}

export type TOpenModalConfiguracoes = {
    open: number | boolean | null;
    edit: boolean
    defaultValue: TCCOConfiguracoes | null;
} | null

const colunas: ConfiguracaoColunas<TCCOConfiguracoes>[] = [
    {
        campo: "nome",
        titulo: "Nome",
    },
];